<template>
  <div :class="{ opened: isOpen }">
    <figure>
      <img
        class="single-box__image__thumbnail"
        :src="displayedImage.src"
        :alt="displayedImage.alt"
        :srcset="displayedImage.srcset"
        :sizes="displayedImage.sizes"
        @click="imageIndex = canOpen ? selectedImage : null"
      />
    </figure>
    <div class="images" v-if="displayOtherImages && images.length">
      <figure
        v-for="(image, index) in images"
        :key="index"
        @click="selectedImage = index"
        :class="{ active: selectedImage === index }"
      >
        <img :src="image.src" :alt="image.alt" :srcset="image.srcset" :sizes="image.sizes" />
      </figure>
    </div>
    <CoolLightBox  v-if="this.images.length " :items="lightboxImages" :index="imageIndex" @close="imageIndex = null" />
  </div>
</template>

<style lang="scss" scoped>
img {
  max-width: 100%;
  width: 100%;
  cursor: pointer;
}

.images {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 1rem;
  width: 100%;
}
</style>
<script>
// use the component
import CoolLightBox from "vue-cool-lightbox";
import "vue-cool-lightbox/dist/vue-cool-lightbox.min.css";

export default {
  name: "Gallery",
  components: {
    CoolLightBox
  },
  props: {
    images: Array,
    thumbnail: Object,
    displayOtherImages: Boolean,
    canOpen: {
      type: Boolean,
      default() {
        return true;
      }
    }
  },
  data() {
    return {
      selectedImage: 0,
      imageIndex: null,
      isOpen: false
    };
  },
  computed: {
    displayedImage() {
      // if (this.images.length) {
      //   return this.images[this.selectedImage];
      // }
      if (this.thumbnail) {
        return { src: ws_vue_store['site_url'] + this.thumbnail.sized };
      }
      return {};
    },
    lightboxImages() {
      if (this.images.length) {
        return this.images;
      }
      if (this.thumbnail) {
        let img = this.thumbnail.full == null ? this.thumbnail.sized : this.thumbnail.full;
        return [{ src: ws_vue_store['site_url'] + img }];
      }
      return [];
    }
  }
};
</script>
